<template>
  <div>
    <EditFileForm />
  </div>
</template>

<script>
import EditFileForm from '../../components/Forms/EditFileForm'

export default {
  name: 'FileEdit',
  components: { EditFileForm }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/FileMgmt/FileEdit.vue?518ef4be